import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcTicketFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.552 4.254a.75.75 0 0 1 .731.584 1.249 1.249 0 0 0 2.434 0 .75.75 0 0 1 .731-.584H20c.966 0 1.75.783 1.75 1.75v12a1.75 1.75 0 0 1-1.75 1.75h-2.552a.75.75 0 0 1-.731-.584 1.248 1.248 0 0 0-2.434 0 .75.75 0 0 1-.731.584H4a1.75 1.75 0 0 1-1.75-1.75v-12c0-.967.784-1.75 1.75-1.75zm1.948 8.5a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75m0-4.5a.75.75 0 0 0-.75.75v1.5a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75",
    clipRule: "evenodd"
  }));
}
var IcTicketFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcTicketFill));

export { IcTicketFill as I };
